import { inject, observer } from "mobx-react";
import React from "react";
import { AiOutlineClose, AiOutlineWarning } from "react-icons/ai";
import { appConfig } from "../config";
import "./DependantPopup.css";

@inject("AppStore")
@observer
class DependantPopup extends React.Component {
  store = this.props.AppStore;

  componentDidMount() {}

  onClose = (e) => {
    e.stopPropagation();
    this.store.popupCloseDependant();
  };

  render() {
    if (!this.store.dependantsPopup.visible) return <React.Fragment />;

    return (
      <div className="dependants" onClick={this.onClose}>
        <div
          className="dependants__wrapper animate__animated animate__zoomIn"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="dependants__header">
            <div className="dependants__title">
              <AiOutlineWarning
                style={{ marginRight: "8px", verticalAlign: "middle" }}
              />
              Warning!
            </div>
            <div className="dependants__close" onClick={this.onClose}>
              <AiOutlineClose fontSize="24" />
            </div>
          </div>
          <div className="dependants__content">
            <div className="dependants__dependant">
              <div className="dependants__option">
                {this.store.dependantsPopup.dependant.picture && (
                  <div className="dependants__option--image">
                    <img
                      alt={this.store.dependantsPopup.dependant.title}
                      src={`${appConfig.api}${this.store.dependantsPopup.dependant.picture.url}`}
                    />
                  </div>
                )}

                <div className="dependants__option--title">
                  {this.store.dependantsPopup.dependant.title}
                </div>
              </div>

              <div className="dependants__info">
                If you remove this option, the selected options below will be
                removed as well.
              </div>
            </div>

            <div className="dependants__dependencies">
              {this.store.dependantsPopup.dependencies.map((dependency, i) => (
                <div className="dependants__option" key={i}>
                  {dependency.picture && (
                    <div className="dependants__option--image">
                      <img
                        alt={dependency.title}
                        src={`${appConfig.api}${dependency.picture.url}`}
                      />
                    </div>
                  )}

                  <div className="dependants__option--title">
                    {dependency.title}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="dependants__footer">
            <div className="modelSelector__cleanbutton">
              <a onClick={this.store.removeDependants}>Approve Removal</a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DependantPopup;
